import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Zones from './components/Zones';
import Presentation from './components/Presentation';
import BeforeAfter from './components/BeforeAfter';
import SocialMedia from './components/SocialMedia';
import Footer from '../home/components/Footer';

export default function SoinsEsthetiquesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <SocialMedia />
      <Benefits />
      <BeforeAfter />
      <Zones />
      <Presentation />
      <SocialMedia />
      <Footer />
    </div>
  );
}
